// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2BHUo","footer":"ReportModalFilter_footer__INDw8"};